import React from "react";

const PartnerEcosystem = () => {
  return (
    <div className="w-full text-gray-800">

      {/* HERO */}
      <section className="bg-gradient-to-r from-teal-900 to-teal-700 text-white py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-semibold mb-6">
            Nobody transforms alone
          </h1>
          <p className="text-lg max-w-2xl opacity-90">
            It takes partners
          </p>
        </div>
      </section>

      {/* IT TAKES PARTNERS */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-semibold mb-4">It takes partners</h2>
            <p className="text-gray-600 leading-relaxed">
              We work with the world’s leading technology companies to help
              clients modernize, optimize, and innovate. Our ecosystem enables
              us to deliver scale, speed, and measurable business outcomes
              across industries.
            </p>
          </div>
          <img
            src="/images/partners/hero.jpg"
            alt="Partners"
            className="rounded-lg shadow-md"
          />
        </div>
      </section>

      {/* PARTNER CARDS */}
      <section className="bg-gray-50 py-16 px-6">
        <div className="max-w-7xl mx-auto space-y-16">

          {/* MICROSOFT */}
          <div className="grid md:grid-cols-2 gap-10 items-center">
            <img src="/images/partners/partner/ms.png" alt="Microsoft" className="rounded-lg" />
            <div>
              <h3 className="text-2xl font-semibold mb-2">Microsoft</h3>
              <h4 className="font-medium mb-3">
                Modernize, migrate, optimize, repeat
              </h4>
              <p className="text-gray-600">
                Accelerate digital transformation using Microsoft Azure, data,
                AI, and cloud-native solutions.
              </p>
            </div>
          </div>

          {/* ADOBE */}
          <div className="grid md:grid-cols-2 gap-10 items-center">
            <div>
              <h3 className="text-2xl font-semibold mb-2">Adobe</h3>
              <h4 className="font-medium mb-3">We are an Adobe Partner</h4>
              <p className="text-gray-600">
                Deliver exceptional digital experiences using Adobe Experience
                Cloud and data-driven personalization.
              </p>
            </div>
            <img src="/images/partners/partner/adobe.jpeg" alt="Adobe" className="rounded-lg" />
          </div>

          {/* SALESFORCE */}
          <div className="grid md:grid-cols-2 gap-10 items-center">
            <img src="/images/partners/partner/salesforce.png" alt="Salesforce" className="rounded-lg" />
            <div>
              <h3 className="text-2xl font-semibold mb-2">Salesforce</h3>
              <h4 className="font-medium mb-3">
                Accelerating Digital with Salesforce solutions
              </h4>
              <p className="text-gray-600">
                Transform customer engagement using Salesforce CRM, analytics,
                and automation platforms.
              </p>
            </div>
          </div>

          {/* DATABRICKS */}
          <div className="grid md:grid-cols-2 gap-10 items-center">
            <div>
              <h3 className="text-2xl font-semibold mb-2">Databricks</h3>
              <h4 className="font-medium mb-3">
                Unified Data. Intelligent AI. Real Outcomes.
              </h4>
              <p className="text-gray-600">
                Enable data engineering, machine learning, and analytics at
                scale.
              </p>
            </div>
            <img src="/images/partners/partner/databrics.jpg" alt="Databricks" className="rounded-lg" />
          </div>

          {/* GOOGLE CLOUD */}
          <div className="grid md:grid-cols-2 gap-10 items-center">
            <img src="/images/partners/partner/google.jpg" alt="Google Cloud" className="rounded-lg" />
            <div>
              <h3 className="text-2xl font-semibold mb-2">Google Cloud</h3>
              <h4 className="font-medium mb-3">
                Evolve everything. And move into the cloud-enabled future.
              </h4>
              <p className="text-gray-600">
                Build, scale, and innovate with Google Cloud AI, analytics, and
                infrastructure.
              </p>
            </div>
          </div>

          {/* APPVANCE */}
          <div className="grid md:grid-cols-2 gap-10 items-center">
            <div>
              <h3 className="text-2xl font-semibold mb-2">Appvance</h3>
              <h4 className="font-medium mb-3">
                Elevate quality engineering with AI
              </h4>
              <p className="text-gray-600">
                AI-driven test automation for faster releases and better quality.
              </p>
            </div>
            <img src="/images/partners/partner/appvance.jpg" alt="Appvance" className="rounded-lg" />
          </div>

          {/* TRICENTIS */}
          <div className="grid md:grid-cols-2 gap-10 items-center">
            <img src="/images/partners/partner/tricentis.jpg" alt="Tricentis" className="rounded-lg" />
            <div>
              <h3 className="text-2xl font-semibold mb-2">Tricentis</h3>
              <h4 className="font-medium mb-3">
                AI powered solutions for modern quality engineering
              </h4>
              <p className="text-gray-600">
                Continuous testing platforms for enterprise-scale applications.
              </p>
            </div>
          </div>

        </div>
      </section>

      {/* TECHNOLOGY ECOSYSTEM */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-semibold mb-8">Technology Ecosystem</h2>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-6 items-center">
            {[
              "aws", "azure", "googlecloud", "databricks", "snowflake",
              "hashicorp", "digitalocean", "dynatrace", "elastic", "crowdstrike"
            ].map((logo) => (
              <img
                key={logo}
                src={`/images/partners/${logo}.png`}
                alt={logo}
                className="mx-auto h-10 object-contain"
              />
            ))}
          </div>
        </div>
      </section>

      {/* ABOUT US */}
      <section className="bg-teal-900 text-white py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-semibold mb-4">About us</h2>
          <p className="max-w-3xl opacity-90">
            We help clients accelerate transformation by combining technology,
            design, and engineering expertise with deep industry knowledge.
          </p>
        </div>
      </section>

      {/* LET'S CONNECT */}
      {/* <section className="bg-black text-white py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-semibold mb-8">Let’s Connect</h2>
          <form className="grid md:grid-cols-3 gap-6">
            <input className="p-3 rounded text-black" placeholder="First Name" />
            <input className="p-3 rounded text-black" placeholder="Last Name" />
            <input className="p-3 rounded text-black" placeholder="Email" />
            <textarea
              className="md:col-span-3 p-3 rounded text-black"
              placeholder="Message"
              rows="4"
            />
            <button className="bg-teal-600 hover:bg-teal-700 px-6 py-3 rounded font-medium md:col-span-3">
              Submit
            </button>
          </form>
        </div>
      </section> */}

    </div>
  );
};

export default PartnerEcosystem;
